import { InputForm, Error, SelectForm } from "components";
import {
  DcddUserInput,
  DcddUserInputError,
  GenericProps,
} from "../../../state/actionType";

interface Formprops {
  formData: DcddUserInput;
  error: DcddUserInputError;
  dzongkhagData: GenericProps[];
  schoolData: GenericProps[];
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
}

const TeacherForm: React.FC<Formprops> = ({
  handleChange,
  formData,
  error,
  dzongkhagData,
  schoolData,
}) => {
  return (
    <div className="grid grid-cols-2 gap-2">
      <div>
        <SelectForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="Dzongkhag"
          id="dzongkhag_id"
          name="dzongkhag_id"
          value={formData.dzongkhag_id}
          option={dzongkhagData?.map((dzongkhag: GenericProps) => (
            <option
              key={dzongkhag.id.toString()}
              value={dzongkhag.id.toString()}
            >
              {dzongkhag.name}
            </option>
          ))}
          onChange={handleChange}
        />
        {error.dzongkhag_id && <Error>{error.dzongkhag_id}</Error>}
      </div>
      <div>
        <SelectForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="School"
          id="school_id"
          name="school_id"
          value={formData.school_id}
          option={schoolData?.map((school: GenericProps) => (
            <option key={school.id.toString()} value={school.id.toString()}>
              {school.name}
            </option>
          ))}
          onChange={handleChange}
        />
        {error.school_id && <Error>{error.school_id}</Error>}
      </div>
      <div>
        <InputForm
          type="text"
          label="CID"
          id="cid"
          name="cid"
          value={formData.cid}
          onChange={handleChange}
        />
      </div>
      <div>
        <InputForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="Email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        {error.email && <Error>{error.email}</Error>}
      </div>
      <div>
        <InputForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="Mobile No."
          id="mobile_no"
          name="mobile_no"
          value={formData.mobile_no}
          onChange={handleChange}
        />
        {error.mobile_no && <Error>{error.mobile_no}</Error>}
      </div>
    </div>
  );
};

export default TeacherForm;
